export const API_HOST = (process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000").replace(/\/$/, "");

export const DOC_LINKS = [
  { label: "API reference", href: `${API_HOST}/v1/docs` },
  { label: "OpenAPI", href: `${API_HOST}/v1/openapi.json` },
  { label: "llms.txt", href: `${API_HOST}/llms.txt` },
  { label: "agents.md", href: `${API_HOST}/developers/agents.md` },
  { label: "MCP", href: `${API_HOST}/.well-known/mcp/server-card.json` },
];

export const MCP_CONFIG = `{
  "mcpServers": {
    "shoptosa": {
      "url": "${API_HOST}/mcp",
      "headers": { "x-api-key": "YOUR_API_KEY" }
    }
  }
}`;

export const STARTER_PROMPT = `Build a shopping assistant on the Shoptosa Graph API.
Base URL: ${API_HOST}/v1
Auth: send x-api-key on every call.
POST /v1/search finds products. POST /v1/lookup opens a product link. POST /v1/chat replies in conversation.
POST /v1/india-compare returns live India prices at 1 credit per store (11 credits for all 11 stores). POST /v1/marketplace-compare returns live US prices at 1 credit per store (10 credits for all 10 stores). Both are refunded if the compare fails.
POST /v1/extract reads one public page (1 credit).
Show merchant, price, and buy_url. Send shoppers through buy_url.
POST /v1/webhooks receives click, conversion, and price_drop. GET /v1/me shows the wallet.`;

export const DEVELOPER_SIGNUP = "/auth?mode=register&role=developer";
